import React from "react";
import { Input } from "../../controls";
import { IconButton, InputAdornment } from "@mui/material";
import Form from "../Form";
import { useTranslation } from "react-i18next";

const DeepSearch = ({ setSearchVal, searchVal, handleSearch }) => {
  const { t } = useTranslation();
  const handleChange = (e) => {
    setSearchVal(e.target.value);
  };

  return (
    <div className="w-full md:w-[250px]">
      <Form noValidate onSubmit={handleSearch}>
        <Input
          name="search"
          placeholder={t("deepSearch")}
          size="small"
          onChange={handleChange} // Fixed name
          value={searchVal}
          sx={{
            "& .MuiInputBase-root": {
              paddingRight: "2px",
            },
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton type="submit" size="small" sx={{ p: "5px" }}>
                  🔍
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Form>
    </div>
  );
};

export default DeepSearch;
